import { AlertTriangle, SparkleOutline } from '@lyearn/icons';
import { EditorOptionType } from '@/components/Editor/PlainEditor/types';
import { TextToneEnum, TextTransformationEnum, TransformTextInput } from '@/types/schema';

import AddAIContent from './components/AIBaseEditor/components/Toolbar/AddAIContent';
import AIDisclaimerTool from './components/AIBaseEditor/components/Toolbar/AIDisclaimerTool';
import {
  discardSuggestion,
  insertBelow,
  keepSuggestion,
  replaceSelection,
} from './utils/editorFunctions';
import { AIEditorActionTypes } from './types';

type AIEditorActionMapValueType =
  | {
      props: Pick<TransformTextInput, 'transformation' | 'tone'>;
      function?: undefined;
      custom?: undefined;
    }
  | {
      props?: undefined;
      function: typeof discardSuggestion;
      custom?: undefined;
    }
  | {
      props?: undefined;
      function?: undefined;
      custom: true;
    };

export const AIEditorActionMap: Record<AIEditorActionTypes, AIEditorActionMapValueType> = {
  // props (text transform API)
  [AIEditorActionTypes.WriteWithLyearnAI]: {
    props: {
      transformation: TextTransformationEnum.Generate,
    },
  },
  [AIEditorActionTypes.MakeLonger]: {
    props: {
      transformation: TextTransformationEnum.Expand,
    },
  },
  [AIEditorActionTypes.MakeShorter]: {
    props: {
      transformation: TextTransformationEnum.Contract,
    },
  },
  [AIEditorActionTypes.Professional]: {
    props: {
      transformation: TextTransformationEnum.ChangeTone,
      tone: TextToneEnum.Professional,
    },
  },
  [AIEditorActionTypes.Casual]: {
    props: {
      transformation: TextTransformationEnum.ChangeTone,
      tone: TextToneEnum.Casual,
    },
  },
  [AIEditorActionTypes.Confident]: {
    props: {
      transformation: TextTransformationEnum.ChangeTone,
      tone: TextToneEnum.Confident,
    },
  },
  [AIEditorActionTypes.Friendly]: {
    props: {
      transformation: TextTransformationEnum.ChangeTone,
      tone: TextToneEnum.Friendly,
    },
  },
  // function (update editor)
  [AIEditorActionTypes.ReplaceSelection]: { function: replaceSelection },
  [AIEditorActionTypes.InsertBelow]: { function: insertBelow },
  [AIEditorActionTypes.Keep]: { function: keepSuggestion },
  [AIEditorActionTypes.Discard]: { function: discardSuggestion },
  // custom
  [AIEditorActionTypes.TryAgain]: { custom: true },
} as const;

export const TOOLBAR_ADD_AI_CONTENT = 'AddAIContent';
export const TOOLBAR_AI_DISCLAIMER = 'AIDisclaimer';

export const EDITOR_AI_OPTION_MAP = new Map<string, EditorOptionType>([
  [
    TOOLBAR_ADD_AI_CONTENT,
    {
      Component: AddAIContent,
      key: TOOLBAR_ADD_AI_CONTENT,
      className: 'me-4',
      classes: {
        popoverContent: '!-ms-12 !mt-[1.7rem]',
      },
      Icon: SparkleOutline,
      blockName: '',
      tooltipKey: 'AI:AskLyearnAI',
    },
  ],
  [
    TOOLBAR_AI_DISCLAIMER,
    {
      Component: AIDisclaimerTool,
      key: TOOLBAR_AI_DISCLAIMER,
      Icon: AlertTriangle,
      blockName: '',
    },
  ],
]);
